module.exports = __webpack_public_path__ + "1642699981952/static/media/banner_default_jobs_desktop.0306c3b4.svg";